var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 8C0.5 3.85786 3.85786 0.5 8 0.5H24C28.1421 0.5 31.5 3.85786 31.5 8V24C31.5 28.1421 28.1421 31.5 24 31.5H8C3.85786 31.5 0.5 28.1421 0.5 24V8Z",
    fill: "#5BA1E8",
    stroke: "#5BA1E8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2891 14.9269C25.237 15.4595 25.237 16.8325 24.2891 17.365L18.2525 20.7566C16.8524 21.5432 15.1476 21.5432 13.7475 20.7566L7.71092 17.365C6.76302 16.8325 6.76303 15.4595 7.71093 14.9269M19.7616 7.43782L18.2525 6.58993C16.8524 5.80336 15.1476 5.80336 13.7475 6.58993L7.71093 9.98149C6.76303 10.514 6.76302 11.887 7.71092 12.4196L13.7475 15.8112C15.1476 16.5977 16.8524 16.5977 18.2525 15.8112L24.2891 12.4196C25.237 11.887 25.237 10.5141 24.2891 9.98149L22.7799 9.1336M24.5828 20C25.0839 20.637 24.9529 21.6455 24.1685 22.0862L18.2525 25.4101C16.8524 26.1966 15.1476 26.1966 13.7475 25.4101L7.9178 22.1347C7.11034 21.6811 6.99816 20.6312 7.54314 20",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu3);
export default __webpack_public_path__ + "static/media/menu3.6cbd6ee25e93a72aad16a76e5720e1e1.svg";
export { ForwardRef as ReactComponent };